"use client";

import { storyblokEditable } from "@storyblok/react";
import Countdown from "react-countdown";
import { sbBlok } from "@/types/sb-types";
import Cta from "./Cta";
import clsx from "clsx";

const renderer = ({ days, hours, minutes, seconds }: any) => {
  return (
    <div className="flex w-fit md:gap-2.5">
      <div className="text-center flex gap-2.5">
        <div className="w-10 flex flex-col md:w-[50px]">
          <div
            className="text-xl md:text-[25px] md:max-h-[30px]"
            suppressHydrationWarning
          >
            {days}
          </div>
          <div className="text-xs md:text-[15px]">days</div>
        </div>
      </div>
      <div className="text-center flex gap-2.5">
        <div className="w-10 flex flex-col md:w-[50px]">
          <div
            className="text-xl md:text-[25px] md:max-h-[30px]"
            suppressHydrationWarning
          >
            {hours}
          </div>
          <div className="text-xs md:text-[15px]">hours</div>
        </div>
      </div>
      <div className="text-center flex gap-2.5">
        <div className="w-10 flex flex-col md:w-[50px]">
          <div
            className="text-xl md:text-[25px] md:max-h-[30px]"
            suppressHydrationWarning
          >
            {minutes}
          </div>
          <div className="text-xs md:text-[15px]">min</div>
        </div>
      </div>
      <div className="text-center flex gap-2.5">
        <div className="w-10 flex flex-col md:w-[50px]">
          <div
            className="text-xl md:text-[25px] md:max-h-[30px]"
            suppressHydrationWarning
          >
            {seconds}
          </div>
          <div className="text-xs md:text-[15px]">sec</div>
        </div>
      </div>
    </div>
  );
};

const CountdownComponent = ({ blok }: sbBlok) => {
  const { countdown_end_time, title, variant, cta_button } = blok;

  return (
    <div
      className={clsx(
        "grid-container mx-0 max-w-full px-0 py-[15px] bg-gradient-to-r from-[#7f3e17] to-tm-c-brand md:py-2.5 lg:py-2",
        {
          "lg:bg-gradient-to-r lg:from-tm-c-brand lg:to-[#7f3e17]":
            variant === "right",
          "lg:bg-gradient-to-l lg:from-[#7f3e17] lg:to-tm-c-brand":
            variant === "left",
          "lg:bg-[radial-gradient(circle,_#7f3e17_0%,_#c06c00)] lg:from-[#7f3e17] lg:to-tm-c-brand":
            variant === "center",
        }
      )}
    >
      <div
        className={clsx(
          "col-start-1 col-span-4 row-start-1 lg:col-start-2 lg:col-span-14 2xl:col-start-2 2xl:col-span-30",
          {
            "xl:ml-[145px]": variant === "right",
            "xl:mr-[145px]": variant === "left",
          }
        )}
      >
        <div
          className={clsx(
            "flex flex-col items-center md:flex-row md:justify-center",
            {
              "lg:justify-end": variant === "right",
              "lg:justify-start": variant === "left",
              "lg:justify-center": variant === "center",
            }
          )}
          {...storyblokEditable(blok)}
        >
          <span className="text-[15px] mb-3 md:text-[17px] md:mr-9 md:mb-0 lg:text-xl">
            {title}
          </span>
          <div className="flex flex-col items-center gap-[15px] min-[360px]:flex-row">
            <Countdown renderer={renderer} date={countdown_end_time} />
            {cta_button?.length > 0 && (
              <Cta
                href={cta_button[0].link.url}
                fullSlug={cta_button[0].link.story?.full_slug}
                name={cta_button[0].name}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CountdownComponent;
